import { render, staticRenderFns } from "./QuotationSettingForm.vue?vue&type=template&id=846e7e70"
import script from "./QuotationSettingForm.vue?vue&type=script&lang=js"
export * from "./QuotationSettingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports